// eslint-disable-next-line import/prefer-default-export
export const TYPE_TO_FIELD_MAP = {
	0: 'string-input',
	1: 'email',
	2: 'phone',
	3: 'checkbox',
	4: 'dropdown',
	5: 'city',
	6: 'upload-explicit',
	7: 'upload-any',
	// 8: '',
	// 9: '',
	10: 'organization',
	11: 'bank',
	12: 'string-input-upload-explicit',
	13: 'passport-number',
	14: 'passport-number-upload-explicit',
	15: 'date-field',
	16: 'date-upload-explicit',
	17: 'address-upload-explicit',
	18: 'field-group',
	19: 'passport-org',
};
